import { render, staticRenderFns } from "./Ppbkldetail.vue?vue&type=template&id=7d615a46"
import script from "./Ppbkldetail.vue?vue&type=script&lang=js"
export * from "./Ppbkldetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports